import { HttpClient } from '../HttpClient';
/**
 * * Post Project Logs
 */
export const PostProjectLogs = async (projectId, postProjectLogsData) => {
  try {
    const { data } = await HttpClient.post(`api/projectLogs/${projectId}/Employees/SearchCriteria`, { ...postProjectLogsData });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
